// utils/commentUtils.ts
import { postLoungeComment, postLoungeCommentWdw } from "../redux/lounges/slice";

const inFlightCommentPosts = new Map<string, Promise<unknown>>();

export function commentSubmitLockKey(park: "dl" | "wdw", chatId: string | number) {
  return `comment:${park}:${chatId}`;
}

export function resetCommentSubmitLockForTests() {
  if (process.env.NODE_ENV === "test") {
    inFlightCommentPosts.clear();
  }
}

export function isCommentSubmitInFlight(chatId?: string | number) {
  if (chatId == null || chatId === "") {
    return false;
  }

  return (
    inFlightCommentPosts.has(commentSubmitLockKey("dl", chatId)) ||
    inFlightCommentPosts.has(commentSubmitLockKey("wdw", chatId))
  );
}

export function waitForCommentSubmitLock(chatId?: string | number): Promise<void> {
  if (chatId == null || chatId === "") {
    return Promise.resolve();
  }

  const pending = [
    inFlightCommentPosts.get(commentSubmitLockKey("dl", chatId)),
    inFlightCommentPosts.get(commentSubmitLockKey("wdw", chatId)),
  ].filter(Boolean) as Promise<unknown>[];

  if (!pending.length) {
    return Promise.resolve();
  }

  return Promise.all(pending).then(() => undefined).catch(() => undefined);
}

export async function withCommentSubmitLock<T>(
  key: string,
  run: () => Promise<T>
): Promise<T | false> {
  const existing = inFlightCommentPosts.get(key);
  if (existing) {
    try {
      await existing;
    } catch {
      // The first caller owns the result and any error UI.
    }
    return false;
  }

  let settleLock: (value?: unknown) => void = () => {};
  const lockPromise = new Promise((resolve) => {
    settleLock = resolve;
  });
  inFlightCommentPosts.set(key, lockPromise);

  try {
    const result = await run();
    settleLock(result);
    return result;
  } catch (error) {
    settleLock(undefined);
    throw error;
  } finally {
    if (inFlightCommentPosts.get(key) === lockPromise) {
      inFlightCommentPosts.delete(key);
    }
  }
}

export const onSubmit1 = async (
  data: any,
  chat_id: string,
  dispatch: any,
  reset: any,
  navigate: any,
  setPostComments: any
): Promise<boolean> => {
  const token = localStorage.getItem("token");
  if (token != null) {
    const chat_msg = data.chat_msg;

    if (chat_msg && chat_msg !== "<p><br></p>") {
      const result = await withCommentSubmitLock(
        commentSubmitLockKey("dl", chat_id),
        async () => {
          const res: any = await dispatch(postLoungeComment({ ...data, chat_id }));
          if (res.payload?.message) {
            window.alert(res.payload.message);
            return false;
          }

          reset();
          setPostComments((prevComments: any) => [
            ...prevComments,
            res.payload.data.commentdata[0],
          ]);
          return true;
        }
      );
      return result === false ? false : result;
    } else {
      alert("Please enter a comment");
      return false;
    }
  } else {
    navigate("/disneyland/login");
    return false;
  }
};

export const onSubmitWdw = async (
  data: any,
  chat_id: string,
  dispatch: any,
  reset: any,
  navigate: any,
  setPostComments: any
): Promise<boolean> => {
  const token = localStorage.getItem("token");
  if (token != null) {
    const chat_msg = data.chat_msg;

    if (chat_msg && chat_msg !== "<p><br></p>") {
      const result = await withCommentSubmitLock(
        commentSubmitLockKey("wdw", chat_id),
        async () => {
          const res: any = await dispatch(postLoungeCommentWdw({ ...data, chat_id }));
          if (res.payload?.message) {
            window.alert(res.payload.message);
            return false;
          }

          reset();
          setPostComments((prevComments: any) => [
            ...prevComments,
            res.payload.data.commentdata[0],
          ]);
          return true;
        }
      );
      return result === false ? false : result;
    } else {
      alert("Please enter a comment");
      return false;
    }
  } else {
    navigate("/disneyland/login");
    return false;
  }
};
